import { render, staticRenderFns } from "./registGuide.vue?vue&type=template&id=1de592b2&scoped=true&"
import script from "./registGuide.vue?vue&type=script&lang=js&"
export * from "./registGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de592b2",
  null
  
)

export default component.exports